import { render } from "./ModalReenviarCorreo.vue?vue&type=template&id=b6239914&scoped=true"
import script from "./ModalReenviarCorreo.vue?vue&type=script&lang=js"
export * from "./ModalReenviarCorreo.vue?vue&type=script&lang=js"

import "./ModalReenviarCorreo.vue?vue&type=style&index=0&id=b6239914&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6239914"]])

export default __exports__